import { Component, OnInit, ViewChild, AfterViewInit, Input, ElementRef } from '@angular/core';
import { LoadedEntry, GameState } from '../../models/coloring-game.models';
import { ColoringGameComponent } from './coloring-game/coloring-game.component';
import { MatDialog } from '@angular/material';
import { ColoringGameDialogComponent } from './coloring-game-dialog/coloring-game-dialog.component';
import { Globals } from 'projects/shared/models/Globals';
declare var entry: any;

@Component({
  selector: 'app-coloring-the-past',
  templateUrl: './coloring-the-past.component.html',
  styleUrls: []
})
export class ColoringThePastComponent implements OnInit, AfterViewInit {


  @Input()
   entry: LoadedEntry;

  @ViewChild('whiteBoardWrapper') child: ColoringGameComponent;

  rangeVal: number=5;
  initialFillColor = "rgba(255,0,0, 255)";
  initialStrokeColor = "rgba(0,0,0, 255)";
  state = GameState.Loading;
  enumGameState = GameState;

  constructor(public dialog : MatDialog) {    
      this.entry = new LoadedEntry();
      this.entry.blackAndWhiteImage = entry.ImageUrl;
      this.entry.information = entry.Description;
      this.entry.level = entry.ComplexityLevel;   
      this.entry.title = entry.Title; 
      this.entry.contentUrlName=entry.ContentUrlName
  }

  finishedDrawing() { this.state = GameState.Ready; }

  done() { 
    this.openDialog(result => {
      if(result) {
        this.finishedDrawing();
      }
    });
  }

  openDialog(subscribeFn : (boolean) => void): void {
    const dialogRef = this.dialog.open(ColoringGameDialogComponent, {
      width: '250px',
      data: { 
        saveFn : _ => this.child.canvasWhiteboard.saveLocal()
      }
    });

    dialogRef.afterClosed().subscribe(subscribeFn);
  }

  ngOnInit() { }

  ngAfterViewInit() {
    this.child.unsubscribeComponentResize();
    this.drawImageFromEntry(this.entry);
    this.createRAngeInput();
  }


  drawImageFromEntry = (entry : LoadedEntry) => { 
    this.child.drawImage(entry, true);
  }
  
  inputRangVal(n: number) {
    this.rangeVal = n;
  }

  createRAngeInput() {
    var x = document.getElementsByTagName("canvas-whiteboard-shape-selector")[0].getElementsByClassName("canvas-whiteboard-shape-selector-wrapper");
    var y = document.getElementsByClassName("sizeStrock");
    if (x.length == 1 && y.length == 0) {
      let div = document.createElement('div');

    document.getElementsByClassName('canvas-whiteboard-shape-selector-wrapper')[0].appendChild(div);
      div.innerHTML = `<span class="sizeStrock"> `+Globals.ViewLocalizedResources.Size+`</span> <input type="range" value="5" id="input-range" min="5" max="50" step="5"/>`;
      
      let inputrange = <HTMLInputElement>document.getElementById("input-range");
      if (inputrange){
        inputrange.value = String(this.rangeVal); 
        inputrange.addEventListener('change', this.rangeChanged.bind(this));
      }
    };
    
  };

  rangeChanged(element){
    window['angularComponentRef'].zone.run(() => {window['angularComponentRef'].component.changeLineWidth(element.target.value)});
  }
}
